import { ImageTemplates } from "~/components/image/types";
import { WindowFormat } from "~/context/breakpoints/types";

export const imageTemplates: ImageTemplates = {
  [WindowFormat.mobile]: "paymentsimage-mobile",
  [WindowFormat.tablet]: "paymentsimage-tablet",
  [WindowFormat.desktop]: "paymentsimage-regulardesktop",
  [WindowFormat.wideDesktop]: "paymentsimage-largedesktop",
};
